export enum ICON_COLOR {
	CURRENT_COLOR = 'currentColor',
	DEFAULT = 'default',
	DISABLED = 'disabled',
	WARNING = 'warning',
	ERROR = 'error',
	SUCCESS = 'success',
	PRIMARY = 'primary',
	WHITE = 'white',
}